module.exports = __webpack_public_path__ + "static/media/bg_downgrade_suggestion_from_35_to_39.42cb80a8.webp";